
<template>
  <div v-if="showDialog" class="claim-overlay">
    <div class="claim-dialog">
      <button
        class="close-button"
        aria-label="Close"
        @click="closeDialog"
      >
        &times;
      </button>

      <div class="claim-content">
        <h2>Claim This Website</h2>

        <p class="offer">
          Claim this website for
          <strong>₦65,000</strong>
          now
        </p>

        <div class="slots">
          Only 25 Slots Remaining
        </div>

        <p class="contact">
          Reach out to us on WhatsApp via
          <a
            href="https://wa.me/+2348123951704"
            target="_blank"
            rel="noopener"
          >
            0812 395 1704
          </a>
          or on any of our social media handles
          <strong>@thevixindustry</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClaimWebsiteDialog',

  data() {
    return {
      showDialog: true
    }
  },

  methods: {
    closeDialog() {
      this.showDialog = false
    }
  }
}
</script>

<style scoped>
.claim-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;
  box-sizing: border-box;

  background: rgba(0, 0, 0, 0.45);
}

.claim-dialog {
  position: relative;

  width: 100%;
  max-width: 520px;

  padding: 45px 40px;
  box-sizing: border-box;

  background: #fff;
  border-radius: 14px;

  text-align: center;

  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.close-button {
  position: absolute;
  top: 12px;
  right: 15px;

  width: 36px;
  height: 36px;

  padding: 0;
  border: 0;

  background: transparent;

  font-size: 28px;
  line-height: 36px;
  color: #777;

  cursor: pointer;
}

.close-button:hover {
  color: #111;
}

.claim-content h2 {
  margin: 0 0 18px;

  font-size: 32px;
  line-height: 1.2;
  color: #111;
}

.offer {
  margin: 0 0 18px;

  font-size: 21px;
  line-height: 1.5;
  color: #333;
}

.offer strong {
  font-size: 25px;
  color: #111;
}

.slots {
  display: inline-block;

  margin-bottom: 22px;
  padding: 9px 18px;

  border-radius: 30px;

  background: #fff0f0;
  color: #d00000;

  font-size: 17px;
  font-weight: 700;
}

.contact {
  margin: 0;

  font-size: 16px;
  line-height: 1.7;
  color: #666;
}

.contact a {
  color: #128c7e;
  font-weight: 700;
  text-decoration: none;
}

.contact a:hover {
  text-decoration: underline;
}

.contact strong {
  color: #222;
}

@media (max-width: 600px) {
  .claim-dialog {
    padding: 40px 25px 30px;
  }

  .claim-content h2 {
    font-size: 27px;
  }

  .offer {
    font-size: 19px;
  }

  .offer strong {
    font-size: 22px;
  }

  .contact {
    font-size: 15px;
  }
}
</style>
